import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {commonService} from "../../services/common.services"; 
import {apiConstants} from "../../constant/api.constant";

const initialState = {
    leaderTreeData: [],
    loading: false,
    error: null,
};

// Async Thunk to fetch countries
export const getTreeDataById = createAsyncThunk(
    "leaderTreeData/getTreeDataById",
    async (data, { rejectWithValue }) => {
        try {
            const response = await commonService.getWithToken(apiConstants.GET_LEADERTREE, data);
            if (response && response.success && response.data) {
                return response.data[0]; // Assuming response.data contains the required array
            } else {
                return rejectWithValue("Failed to fetch tree data.");
            }
        } catch (error) {
            return rejectWithValue(error.message || "An error occurred.");
        }
    }
);

export const leaderTreeSlice = createSlice({
    name: "leaderTreeData",
    initialState,
    reducers: {
        setLeaderTreeData: (state, action) => {
            state.leaderTreeData = [
                ...state.leaderTreeData,
                ...(action.payload?.data || []),
            ];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTreeDataById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTreeDataById.fulfilled, (state, action) => {
                state.loading = false;
                state.leaderTreeData = action.payload || [];
    
            })
            .addCase(getTreeDataById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch data.";
            });
    },
});

export const { setLeaderTreeData } = leaderTreeSlice.actions;
export default leaderTreeSlice.reducer;
